import {
  Component,
  forwardRef,
  Input,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';


@Component({
  selector: 'rfr-datetime-picker',
  templateUrl: './rfr-datetime-picker.component.html',
  styleUrls: ['./rfr-datetime-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RfrDatetimePickerComponent),
      multi: true,
    },
  ],
})
export class RfrDatetimePickerComponent implements ControlValueAccessor {
  selectedDate: string | null = null; // Final value bound to ngModel
  tempSelectedDate: string | null = null; // Temporary value for modal
  isDatePickerOpen = false; // Modal state
  @Input() readonly = false;
  @Input() class = '';
  @Input() style = '';
  @Input() labelText = '';
  @Input() required = false;
  // ControlValueAccessor methods
  private onChange = (value: any) => {};
  private onTouched = () => {};

  writeValue(value: any): void {
    if (value)
      this.selectedDate = value.replace('T', ' ');    
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  // Open the datetime picker modal
  openDateTimePicker() {
    if(this.selectedDate) {
      this.tempSelectedDate = this.selectedDate.replace(' ', 'T');
    }    
    this.isDatePickerOpen = true;
  }

  // Confirm the date selection
  confirmDate() {
    if (!this.tempSelectedDate) {
      return;
    }
    this.selectedDate = this.tempSelectedDate.replace('T', ' ');
    this.onChange(this.selectedDate);
    this.closeDateTimePicker();
  }

  // Cancel the date selection
  cancelDate() {
    this.tempSelectedDate = null;
    this.closeDateTimePicker();
  }

  // Close the modal
  closeDateTimePicker() {
    this.isDatePickerOpen = false;
  }
}